var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_5761)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9993 18.5661C11.999 18.5661 11.9989 18.5664 11.9991 18.5665L16.0093 20.6741C16.7903 21.0841 17.7023 20.4211 17.5533 19.5521L16.9206 15.8638C16.8371 15.3769 16.9987 14.8802 17.3526 14.5356L20.0333 11.9251C20.6653 11.3091 20.3173 10.2361 19.4433 10.1091L15.7398 9.57057C15.2511 9.49952 14.8288 9.19255 14.6104 8.74971L12.9543 5.39208C12.5643 4.60108 11.4353 4.60108 11.0453 5.39208L9.38821 8.74995C9.16975 9.19265 8.74745 9.49951 8.25892 9.57054L4.55526 10.1091C3.68226 10.2361 3.33326 11.3091 3.96526 11.9251L6.64595 14.5356C6.99983 14.8802 7.16137 15.3769 7.07787 15.8638L6.44526 19.5521C6.29626 20.4211 7.20826 21.0851 7.98926 20.6741L11.9994 18.5665C11.9996 18.5664 11.9995 18.5661 11.9993 18.5661V18.5661Z",
    stroke: "#FFB224",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_5761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.797852)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.8e205724220e1dea1faaf21859d51fa2.svg";
export { ForwardRef as ReactComponent };